import React from 'react'
import { Box } from '@mui/material'

const HalfContainer = ({ children, sx }) => (
  <Box sx={{ flex: '1', minWidth: '300px', mr: 1, ...sx }}>{children}</Box>
)

export default HalfContainer
